import { createSelector, createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { BOOKMAKER_FILTER } from "../../utils/enum";

/**
 * Slimmed down to its single remaining responsibility: the
 * currently-selected bookmaker filter chip. The server-side data
 * (leaderboard, user details, followers, following, search results)
 * moved to TanStack Query in Phase 4d — see src/api/hooks/users.ts.
 *
 * Why this stays in Redux: bookmakerFilter is consumed by multiple
 * components across the feed, matches, and odds-dialog surfaces;
 * setting it in one place must instantly reflect in others. That's
 * the textbook UI-state-in-Redux pattern.
 */

export interface IUsersState {
  bookmakerFilter: string;
}

const initialState: IUsersState = {
  bookmakerFilter: BOOKMAKER_FILTER.COMPARISON,
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setBookmakerFilter: (state, action: PayloadAction<string>) => {
      state.bookmakerFilter = action.payload;
    },
  },
});

const { reducer, actions } = usersSlice;
export default reducer;
export const { setBookmakerFilter } = actions;

export const bookmakerFilterSelector = createSelector(
  [(state: { users: IUsersState }) => state.users],
  (item) => item?.bookmakerFilter,
);
